@if (initialized && isError) {
    <div class="p-3 border-round"
         style="background-color: var(--red-50); border: 1px solid var(--red-200);">
        <div class="flex align-items-center gap-2 mb-2">
            <i class="fa-regular fa-circle-exclamation text-red-500 text-xl"></i>
            <span class="text-lg font-medium text-red-600">Fehler</span>
        </div>
        <div class="text-color" style="white-space: pre-wrap;">
            {{ errorMessage || 'Es ist ein Fehler aufgetreten. Es sind keine weiteren Details verfügbar.' }}
        </div>
    </div>
}
